module.exports = __webpack_public_path__ + "img/sup_kyc_10.6f3c8da4.jpg";